import React from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

export const isPremiumImageColumnFormatter = (value) => {
    const subscriptionpackdetails = JSON.parse(localStorage.getItem("subscriptionpackdetails"));
    console.log(subscriptionpackdetails);
    if (subscriptionpackdetails?.isPremium) {
        if (subscriptionpackdetails?.planName) {
          if (subscriptionpackdetails?.planName === "Grandmaster") {
            return <img
              alt={subscriptionpackdetails?.planName}
              src={toAbsoluteUrl("/media/logos/grandMasterIcon.png")}
              className="max-h-50px"
            />
          } else {
            return <img
              alt={subscriptionpackdetails?.planName}
              src={toAbsoluteUrl("/media/logos/championIcon.png")}
              className="max-h-50px"
            />
          }
        } else {
          return <img
            alt={subscriptionpackdetails?.planName}
            src={toAbsoluteUrl("/media/logos/43825.png")}
            className="max-h-50px"
          />
        }
      } else {
        return <span className="data_table_cell_value">
          N/A
        </span>
      }

}